import { IconOptions } from '@jfs/ui-new'

export interface TabProps {
  title?: string
  iconId?: IconOptions
  onSelected: () => void
  state: TabState
  type?: TabType
  isDisabled?: boolean
  onLayout?: (data: any) => void
}

export enum TabType {
  default = 'default',
  arrow = 'arrow',
  highlights = 'highlights',
  recentPayments = 'recentPayments',
  profile = 'profile',
}

export enum TabState {
  normal = 'normal',
  selected = 'selected',
}
